import { render, staticRenderFns } from "./ModattaSettingsProfile.vue?vue&type=template&id=6e764db2"
import script from "./ModattaSettingsProfile.vue?vue&type=script&lang=js"
export * from "./ModattaSettingsProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports